import { css } from "@emotion/react";
import { bpoints } from "../../../../Utils";

export function showPriceCSS() {
    return css`
        position: relative;
        z-index: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 2rem;
       /*  padding-bottom:12rem; */

        @media (max-width: ${bpoints.mobile.w}px){
            padding-top: 2rem;
            padding-bottom: 2rem;

        }

        
        .PreviewPDF{
            z-index: 3;
            iframe{
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
        }

        .PlazosNavigator{
            width: 85%;
            margin-top: 0.2rem;
            display: none;

            color: #21588C;
            font-weight: 500;
            font-size: calc(0.5rem + 2.5vw);

            @media (max-width: ${bpoints.mobile.w}px){
                display: flex;
                justify-content: space-between;
            }

            .NavButton{
                flex-basis: 0;
                flex-grow: 1;

                display: flex;
                cursor: pointer;
            }

            .Left{
                
            }

            .Right{
                flex-basis: 0;
                flex-grow: 1;

                justify-content: flex-end;
            }
        }

        .Note{
            height: 1.5rem;
            margin-top: -0.5rem;
            margin-bottom: 4vh;
            @media (max-width: ${bpoints.mobile.w}px){
                margin-top: 1rem;
                padding: 0 5vw;
            }
            span{
                color: #77787B;
                font-size: calc(0.4rem + 0.6vw);
                width: 100%;
                text-align: center;
                display: block;

                @media (max-width: ${bpoints.mobile.w}px){
                    font-size: calc(0.8rem + 1vw);
                    
                }
            }
        }

        .title{
            font-size: calc(1.4rem + 0.7vw);
            color: #29588C;

            @media (max-width: ${bpoints.mobile.w}px){
                padding: 0 7vw;
                font-size: calc(1.4rem + 1.2vw);

            }
        }
        .mainText{
            font-size: calc(0.6rem + 0.7vw);
            color: black;
            font-weight: 500;
            text-align: center;

            @media (max-width: ${bpoints.mobile.w}px){
                font-size: calc(0.8rem + 1.2vw);
                margin-bottom: 0.5rem;
                padding: 0 4vw;
            }
        }
        .dataText{
            font-size: calc(0.2rem + 0.7vw);
            color: #77787B;

            @media (max-width: ${bpoints.mobile.w}px){
                font-size: calc(0.7rem + 1.5vw);
                flex-direction: column;
                text-align: center;

                .Hyphen{
                    display: none;
                }
            }
        }

        .FormContainer{
            width: 41.6%;

            @media (max-width: ${bpoints.mobile.w}px){
                margin-top: 1rem;
                width: 90%;
            }

            .FormTitleContainer{
                width: 83.3%;

                @media (max-width: ${bpoints.mobile.w}px){
                    width: 100%;
                    margin-top: 4vh;
                }
            }

            .ButtonContainer{
                @media (max-width: ${bpoints.mobile.w}px){
                    width: 100%;
                }
            }
        }

        .Button{
            font-size: calc(0.4rem + 0.7vw);
            position: relative;
            cursor: pointer;
            border-radius: 25px;
            display: flex;
            justify-content: center;
            align-items: center;

            padding: 1rem 0;

            flex-basis: 0;
            flex-grow: 1;

            //transition: 300ms;
            @media (max-width: ${bpoints.mobile.w}px){
                font-size: calc(0.9rem + 0.9vw);
            }
        }   

        .Green{
            background-color: #22EC9A;
            color: white;
            
            border-radius: 17px !important;
            border: unset !important;
            :hover{
                background-color: #2ad690;

            }
        }
        .Blue{
            background-color: #32B8DF;
            color: white;
            
            border-radius: 17px !important;
            border: unset !important;
            :hover{
                background-color: #2da5c8;
            }
        }
        .GradientLeft{
            border: none;
            outline: none;
            background: linear-gradient(to right, #34C6F1, #00BA6E);
            border-radius: 17px;
            z-index: 1;
            //transition: 200ms;
            
            :hover{
                background: #22EC9A;
            }
            
            ::before {
                content: "";
                position: absolute;
                left: 2px;
                right: 2px;
                top: 2px;
                bottom: 2px;
                border-radius: 15px;
                background-color: #f5fcfe;
                z-index: -1;
                transition: 200ms;

                @media (max-width: ${bpoints.mobile.w}px){
                    background-color: #e6f9ff;
                }
            }

            ::after {
                content: attr(data);
               
                color: #00BA6E;
                transition: 200ms;
            }
            
        }

        .GradientLeft:hover::before{
            background-color: #22EC9A;
            
            /* @media (max-width: ${bpoints.mobile.w}px){
                background-color: #e6f9ff;
            } */
        }

        .GradientLeft:hover::after{
            color: #fff;
            /* @media (max-width: ${bpoints.mobile.w}px){
                color: #00BA6E;
            } */
        }

        input::placeholder{
            color: #A7A9AC;
        }

        .TextInput{
            background-color: transparent;
            border-radius: 17px;
            border-color: #34C6F1;
            border-width: 1.5px;
            width: 100%;
            padding: 1rem 1.4rem;

            font-family: 'Neue Haas Grotesk Display Pro' !important;
            font-style: normal;
            font-weight: 600;
            font-size: calc(0.2rem + 0.7vw);
            color: black;
            //height: 4.5rem;
            //font-size: 23px; 
            @media (max-width: ${bpoints.tablet.w}px){
                font-size: calc(0.8rem + 1vw);
            }

            ::placeholder{
                font-weight: 500;
                color: #A7A9AC;
            }
            
        }

        @media (max-width: 799px) {
            .PlazosContainer {
                gap: 1rem !important; /* Para pantallas pequeñas */
            }
        }
        
        @media (min-width: 801px) and (max-width: 1024px) {
            .PlazosContainer {
                gap: 4rem !important; /* Para pantallas medianas */
            }
        }
        
        @media (min-width: 1025px) {
            .PlazosContainer {
                gap: 6rem !important; /* Para pantallas grandes */
            }
        }

        .PlazosContainer{
            position: relative;
            display: flex;
            padding-bottom: 0.5rem;
            padding-top: 1.5rem;
            align-items: center;
            justify-content: center;
            //width: 58.3%;
            padding: 0 1em;
            gap: 6rem; 
            height: 22rem;

            @media (max-width: ${bpoints.mobile.w}px){
                height: 19rem;
                
            }

            .LeftCardContainer{
                // position: absolute;
                left: 0px;
            }
    
            .RightCardContainer{
                // position: absolute;
                right: 0px;
            }
            
            .CardContainer{
                display: flex;
                flex-direction: column;
    
                @media (max-width: ${bpoints.mobile.w}px){
                    position: relative;
                }
                .Card{
                    width: 100%;
                    background: linear-gradient(to right, #34C6F1, #00BA6E);
                    border-radius: 36px 36px 30px 30px;
                    
                    cursor: pointer;
                    .footerCard{
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        border-radius:0 0 35px 35px;
                        background: #22EC9A;
                        color: #22EC9A;

                        padding-top: 1rem;
                        padding-bottom: 0.7rem;

                        .textContent{
                            display: none;
                        }
                    }
        
                    .contentCard{
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        background: white;
                        color: #34C6F1;
                        padding: 1rem 4rem;
                        padding-top: 1.5rem; 
                        padding-bottom: 0.7rem;
                        border-radius: 35px 35px 0 0;
                        margin-top: 1px;
                        margin-left: 1px;
                        margin-right: 1px;
        
                        .months{
                            font-size: calc(4rem + 0.7vw);
                            font-weight: 800;
                            line-height: 0.9;
                        }
        
                        .text{
                            font-size: calc(0.1rem + 0.7vw);
                            font-weight: 600;

                        }
                    }
                }
                .active{
                    background: unset;

                    .footerCard{
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        border-radius:0 0 35px 35px;
                        background: #204B7B;
                        color: #22EC9A;

                        padding-top: 1rem;
                        padding-bottom: 0.7rem;

                        .textContent{
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            
                            .price{
                                font-size: calc(0.9rem + 0.7vw);
                                font-weight: 600;

                                @media (max-width: ${bpoints.mobile.w}px){
                                    font-size: calc(1rem + 3vw);

                                }
                            }
                            
                            .text{
                                font-size: calc(0.2rem + 0.7vw);
                                font-weight: 500;

                                @media (max-width: ${bpoints.mobile.w}px){
                                    font-size: calc(0.6rem + 1.5vw);
                                    
                                }
                            }
                        }
                    }
        
                    .contentCard{
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        background: #22EC9A;
                        color: white;
                        padding: 1rem 5vw;
                        padding-top: 1.5rem;
                        padding-bottom: 0.7rem;
                        border-radius: 35px 35px 0 0;
                        margin-top: 1px;
                        margin-left: 1px;
                        margin-right: 1px;

                        @media (max-width: ${bpoints.mobile.w}px){
                            padding: 1rem 24vw;
                        }

                        .months{
                            font-size: calc(5.4rem + 0.7vw);
                            font-weight: 800;
                            line-height: 0.9;
                        }

                        .text{
                            font-size: calc(0.2rem + 0.7vw);
                            font-weight: 600;
                            @media (max-width: ${bpoints.mobile.w}px){
                                font-size: calc(0.6rem + 1.5vw);
                            }
                        }
                    }
                }
        
                
            }
    
            .InactiveCardContainer{
                @media (max-width: ${bpoints.mobile.w}px){
                    display: none;
                }
            }
        }



        .CappedChip{
            display: inline-block;
            margin-top: 0.35rem;
            padding: 0.15rem 0.55rem;
            border-radius: 999px;
            background: #fdba74;
            color: #7c2d12;
            font-size: 0.7rem;
            font-weight: 600;
            text-align: center;
            line-height: 1.2;
        }

        .shadowCard{
            margin-top: 1rem;
            height: 1.2rem;
            border-radius: 467px;
            background: radial-gradient(50.94% 44.66% at 49.86% 50.14%, rgba(0, 0, 0, 0.14) 0%, rgba(217, 217, 217, 0.00) 100%);
        }

        .backgroundLine{
            width: 285px;
            width: calc(2rem + 14vw);
            height: 1.5px;
            background: linear-gradient(90deg, rgba(32, 75, 123, 0.00) 0%, #204B7B 19.27%, #32B8DF 48.96%, #00BA6E 80.73%, rgba(0, 186, 110, 0.00) 98.44%);
            @media (max-width: ${bpoints.mobile.w}px){
                display: none;
            }
        }

        .BgElement{
            width: calc(1rem + 9vw);
            @media (max-width: ${bpoints.mobile.w}px){
                display: none;
            }
        }
    `;
}